import React, { useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import styled from 'styled-components';
import GenericModal from '../../components/GenericModal';
import GenericTable from '../../components/GenericTable';
import useModalStrip from '../../hooks/global-hooks/useModalStrip';
import { ResultTime } from '../../models/ResultTimes';
import { getAllResultTimes, saveResultTime } from '../../redux/entities/resultTimeEntity';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import AddResultTimePage from './AddResultTimePage';

const PageHeading = styled.h2`
  margin-top: 3rem;
  font-weight: 600;
  color: #4a90e2;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 1.5rem;
  letter-spacing: 0.5px;
`;

const AddButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

const TableWrapper = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 2rem;
`;

const ResultTimePage: React.FC = () => {
  const [modalShow, setModalShow] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false); 
  
  const dispatch = useAppDispatch();
  let resultTimes = useAppSelector((state) => state.entities.resultTimeReducer.resultTimes);
  //const loading = useAppSelector((state) => state.entities.gameReducer.); // assuming you track loading state
  const { showModalStrip } = useModalStrip();

  useEffect(() => {
    // Dispatch getAllGames action only if games are not already loaded
    if (!hasLoaded) {
      dispatch(getAllResultTimes())
        .unwrap()
        .then(() => setHasLoaded(true)) 
        .catch((err: Error) => {
          showModalStrip('danger', err.message, 5000);
        });
    }
  }, [dispatch, hasLoaded, showModalStrip]);

  const columns = [
    { header: 'Result Time', field: 'resultTime' }
  ];


  const handleSaveGame = (resultTime: ResultTime) => {
    dispatch(saveResultTime(resultTime));
    setModalShow(false);
  };

  return (
    <>
      {(
        <Container>
          <PageHeading>Result Time</PageHeading>

          {/* Add New User Button and Search Box */}
          <AddButtonContainer>
            <Button onClick={() => setModalShow(true)}>Add Time</Button>
          </AddButtonContainer>

          {/* Table Wrapper */}
          <TableWrapper>
            <GenericTable
              columns={columns}
              data={resultTimes}
              actions={false} // Don't display the generic edit and delete buttons, we are using custom actions
              pagination={true}
            />
          </TableWrapper>

          {modalShow && (
            <GenericModal
              isOpen={modalShow}
              onClose={() => setModalShow(false)}
              node={<AddResultTimePage data={{} as ResultTime} onSave={(game) => handleSaveGame(game)} />}
              label={'Add Time'}
            />
          )}
        </Container>
      )}
    </>
  );
};

export default ResultTimePage;
